import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { authedAtTimestampAtom } from '../auth/state';
import { useInitGlobalDDLoggerContext } from '../datadog/useInitGlobalDDLoggerContext';
import { visitorStateAtom } from './state';
import { useVisitorId } from './useVisitorId';
import { admissionAttemptsAtom, joinAttemptsAtom } from './waiting-room/admission/state';

export function useInitVisitorGlobalDDLoggerContext() {
  const visitorId = useVisitorId();
  const visitorState = useAtomValue(visitorStateAtom);
  const admissionAttempts = useAtomValue(admissionAttemptsAtom);
  const joinAttempts = useAtomValue(joinAttemptsAtom);
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);
  const { providerShortId } = useParams<{ providerShortId: string }>();

  useInitGlobalDDLoggerContext({
    admissionAttempts,
    providerShortId,
    visitorId,
    visitorState,
    joinAttempts,
    authedAtTimestamp,
  });
}
